<template>
  <div class="activation-page">
    <div class="card">

      <!-- اسم التطبيق -->
      <div class="app-header">🎓 MQBanK+ </div>

      <!-- شاشة البداية -->
      <div v-if="currentScreen === 'start'" class="screen screen-start">

        <p class="subtitle">
          🎓 <strong>أداة التحضير المساعدة لاجتياز اختبارات المقدرة اللغوية واختبارات القيد في اللغة  الانكليزية لطلاب  الماجستير والدكتوراه</strong>
        </p>

        <div class="button-group two-col">
          <button class="btn activate-btn" @click="currentScreen = 'activation'">
            🔐 التفعيل
          </button>

          <button class="btn free-btn" @click="enterFreeVersion">
            {{ freeBtnText }}
          </button>
        </div>

        <!-- بطاقة التنويه -->
        <div class="notice-card">
          <h3 class="notice-title">📚 محتويات أداة MQBank+</h3>

          <div class="notice-text">

           

            <!-- الاختبارات المغطاة -->
            <div class="notice-item">🔸 <strong>اختبار القيد بدرجة دكتوراه (PhD Admission Test)</strong></div>
            <div class="notice-item">🔸 <strong>اختبار القيد بدرجة ماجستير</strong></div>
            <div class="notice-item">🔸 <strong>اختبار تحديد المستوى لطلاب التعليم الافتراضي (PT Placement Test)</strong></div>
            <div class="notice-item">🔸 <strong>اختبار القيد بدرجة ماستر لطلاب التعليم الافتراضي (Master’s Proficiency Test)</strong></div>
            <div class="notice-item">🔸 <strong>الاختبار الوطني للغات (National Language Proficiency Test)</strong></div>

            <hr>

            <!-- المحتوى -->
            <div class="notice-item">
              ✨ المحتوى مبني على
              <strong>تجميع أسئلة الدورات السابقة وحلها مع الترجمة والشرح المفصل والدقيق</strong>
            </div>

            <hr>

            <!-- الذكاء الاصطناعي -->
            <div class="notice-item">🤖 أهمية الذكاء الاصطناعي المدمج داخل الأداة:</div>

            <div class="notice-subitem">
              • بنقرة واحدة على زر <strong>MQBank+ AI</strong> يتم نسخ السؤال مع خيارات الإجابة وإرساله تلقائيًا للأداة المدمجة.  
              • تحصل مباشرة على شرح عميق يوضح <strong>لماذا الإجابة الصحيحة صحيحة</strong> مع القاعدة النحوية واللغوية المرتبطة بها.  
              • كما يوضح <strong>لماذا بقية الخيارات خاطئة</strong>، مما يمنح الطالب فهمًا شاملاً ويعزز قدرته على التمييز بين الإجابات.  
              • الذكاء الاصطناعي هنا يعمل كـ <strong>مدرّس خصوصي ذكي</strong> يرافقك خطوة بخطوة.
            </div>

            <hr>

            <!-- التنويه القانوني -->
            <div class="notice-item" style="color:#b00; font-weight:bold">⚠️ تنويه قانوني:</div>

            <div class="notice-subitem">
              أداة MQBank+ مخصصة لأغراض تدريبية وتعليمية فقط، ولا تمثل أي جهة رسمية أو أكاديمية.  
              المحتوى تدريبي بحت، مأخوذ من تجميع أسئلة دورات سابقة ومواد متداولة بين الطلاب، ويُستخدم حصريًا للمساعدة على التحضير لاجتياز اختبارات المقدرة اللغوية.  
              ناشر MQBank+ لا يتبنى أو يمثل أي مؤسسة تعليمية أو امتحانية؛ الهدف هو توفير وسيلة تدريبية مساعدة للطلاب فقط.
            </div>

          </div>
        </div>

      </div>

      <!-- شاشة التفعيل -->
      <div v-else-if="currentScreen === 'activation'" class="screen screen-activation">

        <h2 class="title">🔑 تفعيل النسخة الكاملة</h2>

        <!-- رمز الجهاز -->
        <div class="section tooltip-wrapper">
          <div class="device-code">{{ deviceId }}</div>

          <button
            :class="['btn copy-btn', { copied }]"
            @click="copyDeviceId"
          >
            {{ copied
              ? '✅ تم نسخ الرمز الخاص بالنسخة الكاملة وأصبح جاهز للارسال عبر زر الواتساب التالي'
              : '📋 اضغط هنا لنسخ الرمز المؤلف من 32 خانة الخاص بالنسخة الكاملة أعلاه وارسله لنا عبر زر الواتساب التالي'
            }}
          </button>
        </div>

        <!-- واتساب -->
        <div class="social-group">
          <button class="btn social whatsapp-btn" @click="sendWhatsApp">
            <i class="fab fa-whatsapp"></i>
          </button>
        </div>

        <!-- كود التفعيل -->
        <div class="section activation-frame">
          <label class="label">كود التفعيل</label>

          <div class="activation-panel">
            <input
              v-model="activationCode"
              type="text"
              placeholder="أدخل كود التفعيل هنا عند استلامه"
              class="activation-input"
              autofocus
            />

            <button
              class="btn activation-btn"
              :class="{ success: activationSuccess }"
              @click="activate"
            >
              <i class="fas fa-key"></i>
              تفعيل
            </button>
          </div>

          <p v-if="activationError" class="error-text">{{ activationError }}</p>
        </div>

        <!-- زر الرجوع -->
        <div class="back-container">
          <button class="back-btn" @click="currentScreen = 'start'">
            ⬅ رجوع
          </button>
        </div>

      </div>

      <!-- شاشة النجاح -->
      <div v-else-if="currentScreen === 'success'" class="screen screen-success">
        <h1 class="title">🎉 تم التفعيل بنجاح</h1>
        <p class="subtitle">يمكنك الآن استخدام جميع الميزات الكاملة!</p>

        <button class="btn free-btn" @click="enterFreeVersion">
          🚀 الدخول للنسخة الكاملة
        </button>
      </div>

      <!-- Toast -->
      <div v-if="showToast" class="toast">✅ تم</div>

      <!-- الفوتر -->
      <footer class="footer-bar">

        <div class="download-link">
          📲 رابط المشاركة  MQBank+:<br>
          👉 <a href="https://mqbankpagedownload.pages.dev" target="_blank">https://mqbankpagedownload.pages.dev</a>
        </div>

        <div class="share-section">
          <div class="share-title">شارك الأداة مع الأصدقاء عبر:</div>

          <div class="share-icons">
            <button class="share-btn whatsapp" @click="shareWhatsApp"><i class="fab fa-whatsapp"></i></button>
            <button class="share-btn telegram" @click="shareTelegram"><i class="fab fa-telegram"></i></button>
            <button class="share-btn sms" @click="shareSMS"><i class="fas fa-sms"></i></button>
            <button class="share-btn facebook" @click="shareFacebook"><i class="fab fa-facebook"></i></button>
          </div>
        </div>

        <div class="like-section">
          <div class="like-text">إذا أعجبك اضغط لايك:</div>

          <button class="like-icon" :disabled="liked" @click="sendLike">
            <i class="fas fa-thumbs-up"></i>
          </button>
        </div>

      </footer>

    </div>
  </div>
</template>


<script>
export default {
  name: 'ActivationPage',
  data() {
    return {
      deviceId: '',
      activationCode: '',
      activationError: '',
      activationSuccess: false,
      copied: false,
      currentScreen: 'start',
      showToast: false,
      liked: false,
      sharedChannels: []
    }
  },
  computed: {
    freeBtnText() {
      return this.activationSuccess
        ? '🚀 الدخول للنسخة الكاملة'
        : '🎁 النسخة المجانية'
    }
  },
  mounted() {
    let id = localStorage.getItem('device_uuid')
    if (!id) {
      id = crypto.randomUUID()
      localStorage.setItem('device_uuid', id)
    }
    this.deviceId = id

    if (localStorage.getItem('activated') === 'true') {
      this.activationSuccess = true
      this.currentScreen = 'success'
    }

    if (!sessionStorage.getItem("session_started")) {
      sessionStorage.setItem("session_started", "true")
      let countKey = `count_${this.deviceId}`
      let count = parseInt(localStorage.getItem(countKey) || '0')
      count++
      localStorage.setItem(countKey, count)

      const fullMessage = `📲 طالب ماستر فتح التطبيق\nDevice ID: ${this.deviceId}\nعدد مرات فتح التطبيق: ${count}\n📅 ${new Date().toLocaleString()}`
      this.notifyTelegram(fullMessage)
    }
  },
  methods: {
    showDoneToast() {
      this.showToast = true
      setTimeout(() => { this.showToast = false }, 2000)
    },

    notifyTelegram(message) {
      const token = "8441222744:AAEn9UToghHSEZ-2ETIONsngRJNz0JD1-Ck"
      const chatId = "8011339494"
      fetch(`https://api.telegram.org/bot${token}/sendMessage`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ chat_id: chatId, text: message })
      })
    },

    // ✅ شاشة التفعيل
    copyDeviceId() {
      navigator.clipboard.writeText(this.deviceId).then(() => {
        this.copied = true
        const message = `📋 طالب ماستر نسخ رمز الجهاز\nDevice ID: ${this.deviceId}\n📅 ${new Date().toLocaleString()}`
        this.notifyTelegram(message)
        this.showDoneToast()
        setTimeout(() => { this.copied = false }, 3000)
      })
    },
    sendWhatsApp() {
      const msg = `${this.deviceId} - MQBank+`
      window.open(`https://wa.me/0937268416?text=${encodeURIComponent(msg)}`, '_blank')
      const message = `📲 طالب ماستر أرسل رمز الجهاز عبر واتساب\nDevice ID: ${this.deviceId}\n📅 ${new Date().toLocaleString()}`
      this.notifyTelegram(message)
      this.showDoneToast()
    },
    sendTelegram() {
      const msg = `${this.deviceId}`
      const url = `https://t.me/RasidkFawriBot?start=${encodeURIComponent(msg)}`
      window.open(url, '_blank')
      const message = `💸 طالب ماستر أرسل رمز الجهاز عبر تلغرام\nDevice ID: ${this.deviceId}\n📅 ${new Date().toLocaleString()}`
      this.notifyTelegram(message)
      this.showDoneToast()
    },
    activate() {
      const valid = btoa(this.deviceId).slice(0, 10)
      if (this.activationCode === valid) {
        localStorage.setItem('activated', 'true')
        this.activationSuccess = true
        this.currentScreen = 'success'
        const message = `🔑 طالب ماستر فعّل النسخة الكاملة\nDevice ID: ${this.deviceId}\n📅 ${new Date().toLocaleString()}`
        this.notifyTelegram(message)
        this.showDoneToast()
      } else {
        this.activationError = '❌ كود التفعيل غير صحيح'
        const message = `❌ طالب ماستر أدخل كود تفعيل غير صحيح\nDevice ID: ${this.deviceId}\n📅 ${new Date().toLocaleString()}`
        this.notifyTelegram(message)
        this.showDoneToast()
      }
    },

    // ✅ الدخول للنسخة
    enterFreeVersion() {
      if (this.activationSuccess) {
        const message = `🚀 طالب ماستر دخل النسخة الكاملة\nDevice ID: ${this.deviceId}\n📅 ${new Date().toLocaleString()}`
        this.notifyTelegram(message)
      } else {
        const message = `🎁 طالب ماستر دخل النسخة المجانية\nDevice ID: ${this.deviceId}\n📅 ${new Date().toLocaleString()}`
        this.notifyTelegram(message)
      }
      this.showDoneToast()
      this.$router.push({
        name: 'QuizPage',
        query: { activated: this.activationSuccess }
      })
    },

    // ✅ المشاركة
    registerShare(channel) {
      if (!this.sharedChannels.includes(channel)) {
        this.sharedChannels.push(channel)
      }
      const message = `🔗 طالب ماستر شارك التطبيق عبر: ${this.sharedChannels.join(', ')}\nDevice ID: ${this.deviceId}\n📅 ${new Date().toLocaleString()}`
      this.notifyTelegram(message)
      this.showDoneToast()
    },
    shareWhatsApp() {
      const msg = `📲 جرّب MQBank+: https://mqbankpagedownload.pages.dev`
      window.open(`https://wa.me/?text=${encodeURIComponent(msg)}`, '_blank')
      this.registerShare("WhatsApp")
    },
    shareTelegram() {
      const msg = `📲 جرّب MQBank+: https://mqbankpagedownload.pages.dev`
      window.open(`https://t.me/share/url?url=${encodeURIComponent(msg)}&text=${encodeURIComponent(msg)}`, '_blank')
      this.registerShare("Telegram")
    },
    shareSMS() {
      const msg = `📲 جرّب MQBank+: https://mqbankpagedownload.pages.dev`
      window.open(`sms:?body=${encodeURIComponent(msg)}`, '_blank')
      this.registerShare("SMS")
    },
    shareFacebook() {
      const url = `https://mqbankpagedownload.pages.dev`
      window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`, '_blank')
      this.registerShare("Facebook")
    },

    // ✅ زر اللايك
    sendLike() {
      if (!this.liked) {
        this.liked = true
        const message = `👍 طالب ماستر ضغط لايك\nDevice ID: ${this.deviceId}\n📅 ${new Date().toLocaleString()}`
        this.notifyTelegram(message)
        this.showDoneToast()
      }
    }
  }
}
</script>



<style scoped>
/* قاعدة عامة لمنع التمرير الأفقي نهائياً */
:host, .activation-page, .card, .screen {
  max-width: 100%;
  overflow-x: hidden;
}
*,
*::before,
*::after {
  box-sizing: border-box;
}

/* الجذر */
.activation-page {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  min-height: 100vh;
  background: linear-gradient(160deg, #0f172a, #1e293b);
  padding: clamp(12px, 3vw, 24px);
  font-family: 'Tajawal', sans-serif;
  color: #fff;
  direction: rtl;
}

/* البطاقة الحاوية */
.card {
  width: 100%;
  max-width: 640px;               /* مساحة أوسع قليلاً مع الحفاظ على الاحتواء */
  margin-inline: auto;
  padding: clamp(16px, 4vw, 28px);
  background: linear-gradient(180deg, rgba(255,255,255,0.08), rgba(255,255,255,0.04));
  border: 1px solid rgba(255,255,255,0.12);
  border-radius: 16px;
  box-shadow: 0 14px 36px rgba(0,0,0,0.5), inset 0 1px 0 rgba(255,255,255,0.06), inset 0 -1px 0 rgba(0,0,0,0.28);
  backdrop-filter: blur(8px) saturate(180%);
  -webkit-backdrop-filter: blur(8px) saturate(180%);
  animation: fadeIn 520ms ease-out both;
  overflow: hidden;               /* حماية من أي فيض داخلي */
}

/* عناوين */
.app-header {
  text-align: center;
  margin-bottom: 2rem;
  font-weight: 900;
  letter-spacing: 0.5px;
  font-size: clamp(2rem, 5vw, 3rem);
  background: linear-gradient(180deg, #f9e7b3 0%, #d4af37 35%, #b8860b 70%, #7a5c1e 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  text-shadow: 0 2px 2px rgba(0,0,0,0.6), 0 -1px 0 rgba(255,255,255,0.3);
}
.title {
  font-size: clamp(1.1rem, 3.2vw, 1.4rem);
  font-weight: 900;
  text-align: center;
  margin-bottom: .6rem;
  letter-spacing: 0.3px;
  background: linear-gradient(180deg, #f7e7b1 0%, #e8d29a 18%, #d7b864 36%, #c59e44 52%, #b4862f 68%, #8d6a24 84%, #5e4717 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  text-shadow: 0 0 0.5px rgba(245, 222, 179, 0.6), 0 1px 2px rgba(0, 0, 0, 0.65);
}
.subtitle {
  font-size: clamp(.95rem, 2.5vw, 1.1rem);
  font-weight: 600;
  color: #f9f9f9;
  text-align: center;
  margin: 1.2rem auto;
  line-height: 1.8;
  max-width: 100%;
  padding-inline: 4px;            /* هامش داخلي بسيط لحماية من قص الحروف */
  text-wrap: pretty;
  overflow-wrap: anywhere;
  word-break: break-word;
  text-shadow: 0 0 8px rgba(0,0,0,0.4);
  letter-spacing: 0.2px;
}

/* الكتل */
.screen {
  width: 100%;
  max-width: 100%;
}
.section {
  text-align: right;
  margin-bottom: 1.25rem;
}

/* بطاقة الملاحظة */
.notice-card {
  background: linear-gradient(135deg, #fff8e1, #fff3cd);
  border: 2px solid #f1c40f;
  border-radius: 14px;
  padding: 1rem;
  margin: 1.25rem 0;
  box-shadow: 0 6px 18px rgba(0,0,0,0.15);
  text-align: right;
  direction: rtl;
  overflow: hidden;
}
.notice-title {
  font-size: 1.1rem;
  font-weight: 800;
  color: #d4af37;
  margin-bottom: 0.5rem;
  text-shadow: 0 0 6px rgba(212,175,55,0.4);
}
.notice-text {
  font-size: .98rem;
  font-weight: 600;
  color: #333;
  line-height: 1.8;
  overflow-wrap: anywhere;
}

/* مجموعات الأزرار */
.button-group {
  display: grid;
  gap: 0.75rem;
  width: 100%;
}
.two-col {
  grid-template-columns: repeat(2, minmax(0, 1fr)); /* يمنع تجاوز العرض */
}
.one-col { grid-template-columns: 1fr; }
.btn {
  padding: 0.75rem;
  font-size: 1rem;
  font-weight: 800;
  border: none;
  border-radius: 0.75rem;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  width: 100%;
  min-width: 0;                          /* لا تسمح بتجاوز العرض */
}
.btn:hover { transform: translateY(-2px); }
.activate-btn { background: linear-gradient(135deg, #22c55e, #16a34a); color: #fff; }
.free-btn { background: linear-gradient(135deg, #facc15, #eab308); color: #1e293b; }

/* إدخالات */
.label {
  font-size: 0.9rem;
  color: #94a3b8;
  margin-bottom: 0.4rem;
  display: block;
}
.device-code {
  padding: 0.75rem;
  background: #273141;
  border: 1px dashed #38bdf8;
  border-radius: 0.5rem;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', monospace;
  font-size: 0.9rem;
  margin-bottom: 0.5rem;
  overflow-x: auto;                     /* السماح بالتمرير الأفقي ضمن العنصر فقط */
  max-width: 100%;
  white-space: nowrap;
}
.activation-frame {
  border: 2px solid #38bdf8;
  border-radius: 0.75rem;
  padding: 1rem;
}
.activation-panel {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 0.5rem;
}
.activation-input {
  min-width: 0;                          /* يمنع تجاوز حقل الإدخال */
  padding: 0.6rem;
  border: 1px solid #38bdf8;
  border-radius: 0.5rem;
  background: transparent;
  color: #fff;
}
.activation-btn {
  background: #38bdf8;
  color: #000;
  padding: 0.6rem 1rem;
  border-radius: 0.5rem;
  font-weight: 800;
}
.activation-btn.success { background: #22c55e; color: #fff; }
.error-text { color: #f87171; font-size: 0.85rem; margin-top: 0.5rem; }

/* شبكات التواصل */
.social-group {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-bottom: 22px;
  flex-wrap: wrap;                      /* التفاف على الشاشات الصغيرة */
}
.whatsapp-btn {
  background: linear-gradient(135deg, #25d366, #128c7e);
  color: #fff;
  font-size: 20px;
  padding: 14px;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(37, 211, 102, 0.4);
}
.whatsapp-btn i { font-size: 22px; }
.whatsapp-btn:hover {
  background: linear-gradient(135deg, #128c7e, #25d366);
  transform: translateY(-3px);
  box-shadow: 0 6px 16px rgba(37, 211, 102, 0.6);
}

/* Toast */
.toast {
  position: fixed;
  inset-inline: 0;
  bottom: 20px;
  margin-inline: auto;
  width: fit-content;
  background: #111;
  color: #00ff7f;
  padding: 0.8rem 1.6rem;
  border-radius: 14px;
  font-weight: bold;
  font-size: 1rem;
  box-shadow: 0 4px 12px rgba(0,255,127,0.4);
  animation: fadeOut 2s forwards;
  z-index: 9999;
}

/* الفوتر */
.footer-bar {
  margin-top: 24px;
  padding: 24px 16px;
  background: #fdfdfd;
  color: #222;
  text-align: center;
  border-top: 1px solid #e0e0e0;
  direction: rtl;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  overflow-x: hidden;
}
.download-link {
  margin: 16px 0;
  font-size: 15px;
  font-weight: 700;
  word-break: break-word;
}
.download-link a {
  color: #007aff;
  text-decoration: none;
  font-weight: 800;
}
.download-link a:hover { text-decoration: underline; }

.share-title {
  font-size: 15px;
  font-weight: 800;
  margin-bottom: 12px;
  color: #333;
}
.share-icons {
  display: flex;
  justify-content: center;
  gap: clamp(14px, 4vw, 28px);
  flex-wrap: wrap;
}
.share-btn {
  font-size: clamp(26px, 5vw, 36px);
  border: none;
  background: none;
  cursor: pointer;
  transition: transform 0.3s ease, color 0.3s ease;
  min-width: 0;
}
.share-btn:hover { transform: scale(1.15) rotate(3deg); }
.share-btn.whatsapp { color: #25D366; }
.share-btn.telegram { color: #0088cc; }
.share-btn.sms { color: #ff9800; }
.share-btn.facebook { color: #1877f2; }

.like-section { margin: 22px 0; }
.like-text { font-size: 15px; font-weight: 800; margin-bottom: 10px; }
.like-icon {
  font-size: 36px;
  color: #d4af37;
  background: none;
  border: none;
  cursor: pointer;
  transition: transform 0.3s ease, opacity 0.3s ease;
}
.like-icon:disabled { opacity: 0.55; cursor: not-allowed; }
.like-icon:hover:not(:disabled) { transform: scale(1.12); }

/* زر الرجوع الدائري */
.back-container {
  display: flex;
  justify-content: center;
  margin-top: 18px;
}
.back-btn {
  background: radial-gradient(circle at 30% 30%, #38bdf8, #0ea5e9);
  color: #fff;
  font-size: 18px;
  font-weight: 800;
  width: 90px;
  height: 90px;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 0 14px rgba(56, 189, 248, 0.7);
  transition: all 0.3s ease;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  animation: pulseBlue 1.6s infinite;
  display: flex;
  align-items: center;
  justify-content: center;
}
.back-btn:hover {
  background: radial-gradient(circle at 30% 30%, #0ea5e9, #38bdf8);
  transform: scale(1.08);
}
.back-btn:active {
  transform: scale(0.96);
  box-shadow: 0 0 8px rgba(56, 189, 248, 0.5);
}

/* حركات */
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(15px); }
  to { opacity: 1; transform: translateY(0); }
}
@keyframes fadeOut {
  0% { opacity: 1; transform: translateY(0); }
  100% { opacity: 0; transform: translateY(10px); }
}
@keyframes pulseBlue {
  0%, 100% { box-shadow: 0 0 14px rgba(56,189,248,0.7); }
  50% { box-shadow: 0 0 22px rgba(56,189,248,0.9); }
}

/* تحسينات خاصة بالموبايل */
@media (max-width: 480px) {
  .card { padding: 14px; }
  .btn { font-size: .95rem; padding: 0.7rem; }
}
</style>